<template>
    <div class="sms-text-box-container">
        <RichTextBox
            v-model="localValue"
            :content-editable="contentEditable"
            :has-error="hasError"
        >
            <template #footer>
                <SmsTextBoxFooter
                    :user-id="userId"
                    :app-id="appId"
                    :source="source"
                    :hide-template-guide="ktvEnabled"
                    :load-ftu-info="!ktvEnabled"
                />
            </template>

            <template #secondaryFooter>
                <SmsTextBoxSecondaryFooter
                    :num-sms-segments="numSmsSegments"
                    :recipient-count="recipientCount"
                    :source="source"
                    :ktv-enabled="ktvEnabled"
                />
            </template>
        </RichTextBox>
    </div>
</template>

<script>
import SmsTextBoxFooter from './SmsTextBoxFooter';
import RichTextBox from './RichTextBox';
import SmsTextBoxSecondaryFooter from './SmsTextBoxSecondaryFooter';
import { getSmsSegments } from '@/components/broadcast/utils/sms-utils';

export default {
    components: {
        RichTextBox,
        SmsTextBoxFooter,
        SmsTextBoxSecondaryFooter,
    },

    props: {
        hasError: Boolean,

        value: {
            type: String,
            default: '',
        },

        userId: String,

        appId: String,

        source: {
            type: String,
            default: 'automation',
        },

        recipientCount: {
            type: Number,
            default: 0,
        },
        ktvEnabled: {
            type: Boolean,
            default: false,
        },
        contentEditable: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            localValue: this.value,
        };
    },

    watch: {
        value(val) {
            if (this.localValue !== val) {
                this.localValue = val;
            }
        },

        localValue(val) {
            if (val !== this.value) {
                this.$emit('input', val);
            }
        },
    },

    computed: {
        numSmsSegments() {
            const { numMessages } = getSmsSegments(this.localValue);

            return numMessages;
        },
    },
};
</script>

<style lang="scss" scoped>
    .merge-field-tooltip {
        margin: $spacing-200;
        font-size: $font-size-md;
        line-height: $line-height-lg;
    }

    .text-box-footer {
        display: flex;
        justify-content: space-between;
        font-size: $font-size-xs;
    }

    .error-message {
        color: $color-red;
    }

    .character-count {
        color: $color-text-subtle;

        &.error {
            color: $color-red;
        }
    }
</style>
